import module from 'fan/proyecto/module.js'

export const FanProyectoColaboradoresSchema = {
  imss_fecha_alta: 'date',
  activo: 'boolean',
  cliente: {
    fecha_ingreso: 'date',
  },
  contrato: {
    absorber_cuota_obrera: 'boolean',
    absorber_cuota_patronal: 'boolean',
    absorber_impuesto_estatal: 'boolean',
    absorber_isr: 'boolean',
    clase: 'number',
    comision_porcentaje: 'number',
    id_estado: 'number',
    id_jornada: 'number',
    id_peridiocidad: 'number',
    id_regimen_fiscal: 'number',
    id_tipo_contrato: 'number',
    tipo_salario_id: 'number',
    tipo_colaborador_id: 'number',
    fecha_alta: 'date',
    salario_diario: 'number',
    salario_diario_integrado: 'number',
    salario_neto_integral: 'number',
  },
  cuentas: {
    id_moneda: 'number',
  },
  personal: {
    fecha_nacimiento: 'date',
  },
}

export class FanProyectoColaboradoresService {
  constructor($http) {
    this.$http = $http
  }

  get(id_proyecto) {
    return this.$http.get('/api2/proyecto/colaboradores', {
      params: {id_proyecto: id_proyecto},
      schema: FanProyectoColaboradoresSchema,
    })
  }

  post(id_proyecto, data) {
    return this.$http.post('/api2/proyecto/colaboradores', data, {
      params: {id_proyecto: id_proyecto},
      schema: FanProyectoColaboradoresSchema,
    })
  }
}

module.service('FanProyectoColaboradoresService', FanProyectoColaboradoresService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Colaboradores.js